<div class="login-page-container">
  <div class="login-container">
    <div class="login-content">
      <div class="left-panel">
        <div class="brand-lockup">
          <div class="brand-mark">
            <img
              src="/time-tracker-logo.svg"
              alt="Time Tracker logo"
              class="brand-logo"
            />
          </div>

          <div class="brand-copy">
            <p class="brand-eyebrow">Smart time reporting</p>
            <h1 class="main-title">Time Tracker</h1>
            <p class="subtitle">
              Stay focused, capture hours, and keep projects moving.
            </p>
          </div>
        </div>
      </div>

      <div class="right-panel">
        <h2 class="welcome-text">Login</h2>
        <p class="login-instruction">Log in to your account</p>

        @if (linkRequired()) {
        <div class="link-account-panel">
          <p class="link-account-copy">
            A Google account with this email already exists. Enter your password
            to link Google sign-in to your existing account.
          </p>

          <div class="form-group">
            <label for="link-password" class="visually-hidden">Password</label>
            <div class="input-with-icon">
              <i class="bi bi-lock"></i>
              <input
                type="password"
                class="form-control"
                id="link-password"
                [ngModel]="linkPassword()"
                (ngModelChange)="linkPassword.set($event)"
                name="linkPassword"
                placeholder="Password"
                required
              />
            </div>
          </div>

          @if (error()) {
          <div class="alert alert-danger mb-3">{{ error() }}</div>
          }

          <button
            type="button"
            class="btn btn-primary login-btn"
            [disabled]="!linkPassword() || linkLoading()"
            (click)="onLinkAccount()"
          >
            @if (linkLoading()) {
            <span
              class="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
            } Link and continue
          </button>
        </div>
        } @else {
        <form (ngSubmit)="onSubmit()">
          <div class="form-group">
            <label for="email" class="visually-hidden">Email address</label>
            <div class="input-with-icon">
              <i class="bi bi-envelope"></i>
              <input
                type="email"
                class="form-control"
                id="email"
                [ngModel]="email()"
                (ngModelChange)="email.set($event)"
                name="email"
                placeholder="Email address"
                required
              />
            </div>
          </div>

          <div class="form-group">
            <label for="password" class="visually-hidden">Password</label>
            <div class="input-with-icon">
              <i class="bi bi-lock"></i>
              <input
                type="password"
                class="form-control"
                id="password"
                [ngModel]="password()"
                (ngModelChange)="password.set($event)"
                name="password"
                placeholder="Password"
                required
              />
            </div>
          </div>

          @if (error()) {
          <div class="alert alert-danger mb-3">{{ error() }}</div>
          }

          <p class="signup-link">
            Forgot your password? <a href="/forgot-password">Reset password</a>
          </p>

          <button
            type="submit"
            class="btn btn-primary login-btn"
            [disabled]="!isFormValid() || loading()"
          >
            @if (loading()) {
            <span
              class="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
            } Log in
          </button>
        </form>

        @if (googleEnabled()) {
        <div class="sso-divider">
          <span>or</span>
        </div>

        <button
          type="button"
          class="btn btn-outline-secondary google-btn"
          [disabled]="googleLoading() || loading()"
          (click)="onGoogleLogin()"
        >
          @if (googleLoading()) {
          <span
            class="spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"
          ></span>
          }
          <i class="bi bi-google me-2"></i>
          Continue with Google
        </button>
        }
        }
      </div>
    </div>
  </div>
</div>
